import {
  FleetWarehouse,
  FleetWarehouseEditFormValues,
  FleetWarehouseRow,
  WarehouseWorkingDay,
} from "./types";
import { WAREHOUSE_DEFAULT_OPEN_FROM, WAREHOUSE_DEFAULT_OPEN_TO, WAREHOUSE_WEEK_DAYS } from "./consts";

/**
 * Uvijek svih sedam dana, redom od ponedjeljka. Dan bez zapisa je zatvoren, a vrijeme mu je
 * unaprijed upisano da se pri otvaranju ne tipka ispočetka.
 */
export const transformWarehouseWorkingHours = (days: any[] | null | undefined): WarehouseWorkingDay[] =>
  WAREHOUSE_WEEK_DAYS.map(({ day }) => {
    const saved = (days ?? []).find((d: any) => d.day === day);
    return {
      day,
      isOpen: saved?.isOpen ?? false,
      from: saved?.from ?? WAREHOUSE_DEFAULT_OPEN_FROM,
      to: saved?.to ?? WAREHOUSE_DEFAULT_OPEN_TO,
    };
  });

/** Vrijeme za prikaz: cijeli dan se piše kao "0 do 24 h". */
export const formatWarehouseHours = (from: string | null, to: string | null) =>
  from === "00:00" && to === "24:00" ? "0 do 24 h" : `${from} do ${to}`;

/** Današnji dan po našem brojanju: 1 = ponedjeljak … 7 = nedjelja. */
export const getWarehouseToday = () => {
  const day = new Date().getDay();
  return day === 0 ? 7 : day;
};

export const transformFleetWarehouseRow = (res: any): FleetWarehouseRow => {
  return {
    id: res.id,
    image: res.image,
    name: res.name,
    description: res.description ?? null,
    workingHours: transformWarehouseWorkingHours(res.workingHours),
    addressCity: res.addressCity,
    addressCountry: res.addressCountry,
    addressLine1: res.addressLine1,
    addressLine2: res.addressLine2,
    addressPostalCode: res.addressPostalCode,
    addressState: res.addressState,
    addressLatitude: res.addressLatitude,
    addressLongitude: res.addressLongitude,
    contacts: res.contacts,
  };
};

/*---------------------------------------------------------------------------------------
      VEHICLE CATEGORY CREATE/EDIT
  -----------------------------------------------------------------------------------------*/

export const transformFleetWarehouseOnCreate = (
  formValues: FleetWarehouseEditFormValues
): any => ({
  name: formValues.name,
  addressCity: formValues.addressCity,
  addressCountry: formValues.addressCountry,
  addressLine1: formValues.addressLine1,
  addressLine2: formValues.addressLine2,
  addressPostalCode: formValues.addressPostalCode,
  addressState: formValues.addressState,
  addressLatitude: formValues.addressLatitude,
  addressLongitude: formValues.addressLongitude,
  description: formValues.description,
  workingHours: formValues.workingHours,
  contactIds: formValues.contacts?.map((contact) => contact.id) ?? [],
});

export const transformFleetWarehouseOnUpdate = (
  formValues: FleetWarehouseEditFormValues
): any => ({
  id: formValues.id,
  name: formValues.name,
  addressCity: formValues.addressCity,
  addressCountry: formValues.addressCountry,
  addressLine1: formValues.addressLine1,
  addressLine2: formValues.addressLine2,
  addressPostalCode: formValues.addressPostalCode,
  addressState: formValues.addressState,
  addressLatitude: formValues.addressLatitude,
  addressLongitude: formValues.addressLongitude,
  description: formValues.description,
  workingHours: formValues.workingHours,
  contactIds: formValues.contacts?.map((contact) => contact.id) ?? [],
});

export const transformFleetWarehouse = (res: any): FleetWarehouse => {

  return {
    id: res.id,
    image: res.image,
    name: res.name,
    addressCity: res.addressCity,
    addressCountry: res.addressCountry,
    addressLine1: res.addressLine1,
    addressLine2: res.addressLine2,
    addressPostalCode: res.addressPostalCode,
    addressState: res.addressState,
    addressLatitude: res.addressLatitude,
    addressLongitude: res.addressLongitude,
    description: res.description ?? null,
    workingHours: transformWarehouseWorkingHours(res.workingHours),
    contacts: res.contacts,
  };
};


